import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Rate } from '../comun/recipient-services/rate';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class RatingsService extends ApiService  {
  constructor() {
    super('ratings');

  }
  
  crear(rate: Rate): Observable<void> {
    return this.http.get<void>(this.url(''), 
    {params: new HttpParams()
    .set('score', rate.Score).set('comments', rate.Comments)});
  }
}
